<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :items-per-page="10"
      hide-default-footer
    >
      <template v-slot:item.status="{}">
        <v-btn rounded dense small class="green2" outlined color="primary"
          >Active</v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  props: {
    epdId: Number,
  },
  async mounted() {
    this.startLoading();
    const ownership = await AnimalService.getOwnership(this.epdId);

    if (ownership?.data) {
      const ownershipData = ownership?.data?.getOwnership;
      this.desserts[0].ownerName =
        ownershipData?.ownerName || ownershipData?.user?.name || "-";
      this.desserts[0].ranch = ownershipData?.ranch || "-";
      this.desserts[0].dateOwned = ownershipData?.dateOwned || "-";
      this.desserts[0].percentOwnership =
        ownershipData?.percentOwnership || "-";
      this.desserts[0].email = ownershipData?.user?.email || "-";
      this.desserts[0].phone = ownershipData?.user?.mobile || "-";

      // this.stopLoading();
      this.loading = false;
    } else if (ownership?.errors) {
      this.loading = false;

      console.log(ownership?.errors);
    }
    this.stopLoading();
  },
  data() {
    return {
      desserts: [
        {
          ownerName: "-",
          ranch: "-",
          dateOwned: "-",
          percentOwnership: "-",
          email: "-",
          phone: "-",
        },
      ],
      headers: [
        {
          text: this.$t("Owner Name"),
          value: "ownerName",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Ranch"),
          value: "ranch",
          sortable: false,
          align: "start",
          class: "black--text ",
          width: "10%",
        },
        {
          text: this.$t("Date Owned"),
          value: "dateOwned",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Percent Ownership"),
          value: "percentOwnership",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Email"),
          value: "email",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("Phone Number"),
          value: "phone",
          class: "black--text px-0",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  mixins: [loadingMixin],
};
</script>
